import { CalendarClock } from "lucide-react";
import { mxn, fdate } from "@/lib/format";
import { PERIODICIDAD_FACTORAJE } from "@/lib/factoraje";

const COLOR_ESTATUS = { Pagada: "text-emerald-600", Vencida: "text-red-600", Parcial: "text-amber-600" };

/** Factoraje (Build 2): tabla de UNA sola cuota con días exactos y descuento (interés). */
export function TablaFactoraje({ tabla, dataTestid = "tabla-factoraje", conEstatus = true }) {
  if (!tabla || tabla.length === 0) {
    return (
      <div className="rounded-md border border-dashed border-slate-300 bg-slate-50 p-4 text-center text-xs text-slate-500"
        data-testid={`${dataTestid}-empty`}>
        Sin tabla de amortización.
      </div>
    );
  }
  const venc = tabla[0].fecha_vencimiento_factura;
  const recorrida = venc && String(tabla[0].fecha_pago).slice(0, 10) !== String(venc).slice(0, 10);
  return (
    <div className="overflow-hidden rounded-md border border-slate-200 bg-white" data-testid={dataTestid}>
      <div className="flex flex-wrap items-baseline justify-between gap-2 border-b border-slate-100 bg-slate-50 px-3 py-2">
        <p className="text-sm font-semibold text-slate-800" data-testid={`${dataTestid}-titulo`}>{PERIODICIDAD_FACTORAJE}</p>
        {venc && (
          <p className="text-[11px] text-slate-500" data-testid={`${dataTestid}-vencimiento`}>
            Vencimiento de la factura: <b className="text-slate-700">{fdate(venc)}</b>
          </p>
        )}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm">
          <thead className="bg-slate-50">
            <tr className="text-xs uppercase tracking-wide text-slate-500">
              <th className="px-3 py-2">#</th>
              <th className="px-3 py-2">Fecha de pago</th>
              <th className="px-3 py-2 text-right">Días</th>
              <th className="px-3 py-2 text-right">Capital</th>
              <th className="px-3 py-2 text-right">Descuento (interés)</th>
              <th className="px-3 py-2 text-right">IVA</th>
              <th className="px-3 py-2 text-right">Total</th>
              <th className="px-3 py-2 text-right">Saldo</th>
              {conEstatus && <th className="px-3 py-2 text-right">Estatus</th>}
            </tr>
          </thead>
          <tbody>
            {tabla.map((c) => (
              <tr key={c.no} className="border-t border-slate-100 tabular-nums" data-testid={`${dataTestid}-fila-${c.no}`}>
                <td className="px-3 py-2 text-slate-500">{c.no}</td>
                <td className="px-3 py-2 text-slate-600">{fdate(c.fecha_pago)}</td>
                <td className="px-3 py-2 text-right font-mono" data-testid={`${dataTestid}-dias`}>{c.dias_descuento ?? "—"}</td>
                <td className="px-3 py-2 text-right font-mono">{mxn(c.capital)}</td>
                <td className="px-3 py-2 text-right font-mono" data-testid={`${dataTestid}-descuento`}>{mxn(c.interes)}</td>
                <td className="px-3 py-2 text-right font-mono">{mxn(c.iva_interes)}</td>
                <td className="px-3 py-2 text-right font-mono font-semibold" data-testid={`${dataTestid}-total`}>{mxn(c.total_periodo ?? c.pago)}</td>
                <td className="px-3 py-2 text-right font-mono text-slate-500">{mxn(c.saldo_insoluto)}</td>
                {conEstatus && (
                  <td className="px-3 py-2 text-right text-xs">
                    <span className={COLOR_ESTATUS[c.estatus] || "text-slate-500"}>{c.estatus || "Pendiente"}</span>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {recorrida && (
        <p className="flex items-start gap-1.5 border-t border-slate-100 px-3 py-2 text-[11px] text-sky-800"
          data-testid={`${dataTestid}-recorrida`}>
          <CalendarClock className="mt-0.5 h-3.5 w-3.5 shrink-0" />
          La factura vence en día inhábil ({fdate(venc)}): el pago se recorre al siguiente día hábil y los días se
          cuentan al vencimiento original.
        </p>
      )}
    </div>
  );
}
